import { render, staticRenderFns } from "./TermType.vue?vue&type=template&id=731d9d49"
import script from "./TermType.vue?vue&type=script&lang=js"
export * from "./TermType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports